import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { components } from "react-select";
import SVGFlagIcon from "~components/atoms/svg_flag_icon/svg_flag_icon";
import countryToIsoCode from "~utils/country_utils/country_to_iso_code";

const ReactSelectFlagIconMultiValue = (props) => {
  const { MultiValue } = components;
  const officeName = props.data.label;
  const countryCode = useMemo(() => {
    return countryToIsoCode(officeName);
  }, [officeName]);

  return (
    <MultiValue {...props}>
      <SVGFlagIcon
        small
        marginRight
        countryCode={countryCode}
        altText={`${props.data.label}`}
      />
      {props.data.label}
    </MultiValue>
  );
};

ReactSelectFlagIconMultiValue.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
  selectProps: PropTypes.shape({
    selectProps: PropTypes.shape({
      offices: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }),
};

ReactSelectFlagIconMultiValue.defaultProps = {
  selectProps: null,
};

export default ReactSelectFlagIconMultiValue;
